import { useState, FC } from "react";
import classNames from "classnames";
import styles from "./styles.module.scss";

interface Month {
  id: string;
  label: string;
}

export const Range: FC = () => {
  const months: Month[] = [
    { id: "2024-12-a", label: "Dec 2024" },
    { id: "2024-07", label: "Jul 2024" },
    { id: "2024-08", label: "Aug 2024" },
    { id: "2024-09", label: "Sep 2024" },
    { id: "2024-10", label: "Oct 2024" },
    { id: "2024-11", label: "Nov 2024" },
    { id: "2024-12-b", label: "Dec 2024" },
    { id: "2025-01", label: "Jan 2025" },
    { id: "2025-02", label: "Feb 2025" },
    { id: "2025-03", label: "Mar 2025" },
  ];
  const [active, setActive] = useState(4);

  return (
    <div className={styles.range}>
      <div className={styles.monthsLine}>
        {months.map((month, i) => (
          <button
            key={month.id}
            type="button"
            className={classNames(styles.month, {
              [styles.active]: i === active,
            })}
            onClick={() => setActive(i)}
          >
            {month.label}
          </button>
        ))}
      </div>
    </div>
  );
};
